import script from "./WhatIsArea.vue?vue&type=script&setup=true&lang=js"
export * from "./WhatIsArea.vue?vue&type=script&setup=true&lang=js"

import "./WhatIsArea.vue?vue&type=style&index=0&id=5a00702c&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a00702c"]])

export default __exports__